var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Vue2DateRangePicker',{attrs:{"startDate":_vm.start,"endDate":_vm.end,"locale-data":_vm.locale,"opens":_vm.opens,"autoApply":_vm.autoApply,"ranges":_vm.ranges},on:{"update":function (value) {
            this$1.$emit('update', value);

            this$1.start = value.startDate;
            this$1.end = value.endDate;
        }}},[_c('div',{attrs:{"slot":"input"},slot:"input"},[_vm._t("input",[_c('vs-button',{attrs:{"color":"primary","type":"flat","icon-pack":"feather","icon":"icon-chevron-down","icon-after":""}},[_vm._v(_vm._s(_vm.rangeText))])])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }